<template>
  <div class="app-footer bg-color-light-translucent w-full">
    <div
      class="row-center px-3 pt-2 pb-1"
      :class="IsMobileScreen ? 'justify-center' : 'justify-between'"
    >
      <div v-if="!IsMobileScreen" class="row-center">
        <i class="ti ti-circle-letter-c color-primary text-m me-2"></i>
        <div class="flex flex-row text-s leading-m">
          <div>{{ CompanyProfile.CompanyName }}</div>
          <div>{{ copyrightYear }}</div>
        </div>
      </div>
      <div v-else></div>
      <div
        v-if="!IsCustomDomain"
        class="row-center flex-1"
        :class="IsMobileScreen ? 'justify-around' : 'justify-end gap-4 ms-3'"
      >
        <a v-for="footerLink in footerLinks" :href="footerLink.link" target="_blank">
          <i :class="`ti ti-${footerLink.icon} color-primary text-m`"></i>
        </a>
      </div>
      <div v-if="!IsProductionEnv" class="text-xs font-semibold color-danger text-center ms-2">
        <span v-if="ClientNativeVersion">{{ ClientNativeVersion }} | </span>
        <span>{{ ClientWebVersion }} </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useAppSettingsStore } from "@/stores/core/appSettingsStore";
import { storeToRefs } from "pinia";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "TheAppFooter",
  setup() {
    const appSettingsStore = useAppSettingsStore();
    const {
      IsCustomDomain,
      CompanyProfile,
      IsMobileScreen,
      IsProductionEnv,
      ClientWebVersion,
      ClientNativeVersion,
    } = storeToRefs(appSettingsStore);
    const copyrightYear = new Date().getFullYear();
    const footerLinks = computed(() => {
      const allLinks = [];
      const socialMediaItems = CompanyProfile.value.SocialMedia;
      for (const key in socialMediaItems) {
        const socialMediaUrl = socialMediaItems[key as keyof typeof socialMediaItems];
        if (socialMediaUrl === null) {
          continue;
        }
        allLinks.push({ link: socialMediaUrl, icon: `brand-${key.toLowerCase()}` });
      }
      return allLinks;
    });

    return {
      IsMobileScreen,
      IsCustomDomain,
      IsProductionEnv,
      ClientWebVersion,
      ClientNativeVersion,
      footerLinks,
      CompanyProfile,
      copyrightYear,
    };
  },
});
</script>

<style lang="scss" scoped>
// scoped-defer: bucket-a-leakage: unmappable decl(s): box-shadow with color-mix
.app-footer {
  box-shadow: 0 0 7px 0 color-mix(in srgb, var(--color-dark) 10%, transparent);
}
</style>
